"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _FormControl2 = _interopRequireDefault(require("@material-ui/core/FormControl"));

var _Select2 = _interopRequireDefault(require("@material-ui/core/Select"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Duration = function Duration(_ref) {
  var _ref$options = _ref.options,
      options = _ref$options === void 0 ? {} : _ref$options,
      setOptions = _ref.setOptions;
  var format = (options === null || options === void 0 ? void 0 : options.format) || "h:mm";

  var setFormat = function setFormat(value) {
    setOptions(_objectSpread(_objectSpread({}, options), {}, {
      format: value
    }));
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      paddingRight: "1rem",
      fontSize: "0.875rem",
      marginTop: "0.25rem",
      color: "rgba(156, 163, 175, 1)"
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      color: "rgba(75, 85, 99, 1)",
      marginTop: "0.75rem"
    }
  }, "Duration format"), /*#__PURE__*/_react["default"].createElement(_FormControl2["default"], {
    variant: "outlined",
    size: "small",
    fullWidth: true,
    style: {
      marginTop: "0.25rem"
    }
  }, /*#__PURE__*/_react["default"].createElement(_Select2["default"], {
    "native": true,
    value: format,
    onChange: function onChange(e) {
      return setFormat(e.target.value);
    }
  }, /*#__PURE__*/_react["default"].createElement("option", {
    value: "h:mm"
  }, "h:mm (e.g. 1:23)"), /*#__PURE__*/_react["default"].createElement("option", {
    value: "h:mm:ss"
  }, "h:mm:ss (e.g. 3:45, 1:23:40)"), /*#__PURE__*/_react["default"].createElement("option", {
    value: "h:mm:ss.s"
  }, "h:mm:ss.s (e.g. 3:45:6, 1:23:40.0)"), /*#__PURE__*/_react["default"].createElement("option", {
    value: "h:mm:ss.ss"
  }, "h:mm:ss.ss (e.g. 3:45.67, 1:23:40.00)"), /*#__PURE__*/_react["default"].createElement("option", {
    value: "h:mm:ss.sss"
  }, "h:mm:ss.sss (e.g. 3:45.678, 1:23:40.000)"))));
};

var _default = Duration;
exports["default"] = _default;